export const ERROR_SELECT_YEAR_AND_MONTH = "You must select a year and month if you select a day.";
export const ERROR_SELECT_YEAR_IF_MONTH = "You must select a year if you select a month.";
export const ERROR_SELECT_YEAR = "You must select a year";

export const FIRST_USE_DATE_MISMATCH = "First use date does not match entered age";
export const LAST_USE_DATE_MISMATCH = "Last use date does not match entered age";
export const FIRST_USE_LABEL = "First Use";
export const LAST_USE_LABEL = "Last Use";



// WEBPACK FOOTER //
// ./src/scripts/constants/dateValidationConstants.js